import { toSnakeCase } from "../../../../utils/toSnakeCase";

export const useWoburnReassignmentReportColumns = (headers) => {
  return headers.map(item=>({		
      headerName: item,
      field: toSnakeCase(item),
	}))		 
};

export default useWoburnReassignmentReportColumns;
